<template>
  <div class="navlk">
    <router-link
      v-for="(item, index) in menu"
      :key="index"
      :to="{ name: item.code }"
      style="cursor: pointer"
      v-show="!webMode || item.code === 'dbuy' || item.code === 'msg'"
      @click.native="playSound"
      ><img :src="`/assets/img/nav-${item.code}.svg`" alt="" />
      {{ item.name }}</router-link
    >
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";

export default {
  name: "CompMenu",
  props: {},
  computed: {
    ...mapGetters({
      webMode: "webMode",
    }),
    ...mapState({
      menu: (state) => state.website.menu,
    }),
  },
  methods:{
    playSound(){
      this.$bus.$emit("play:music", 'menu_change');
    }
  }
};
</script>


